import React from 'react';

export default function Guide({ t }) {
  const steps = [
    { title: t.step1title, text: t.step1text },
    { title: t.step2title, text: t.step2text },
    { title: t.step3title, text: t.step3text },
    { title: t.step4title, text: t.step4text },
  ];

  return (
    <div>
      <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', color: 'var(--wow-gold)' }}>
        {t.title}
      </h2>
      {steps.map((step, index) => (
        <div key={index} style={{ marginBottom: '24px' }}>
          <h3 style={{ fontWeight: 'bold', marginBottom: '4px', color: 'var(--wow-gold-light)' }}>
            {step.title}
          </h3>
          <p style={{ color: 'var(--wow-text)', lineHeight: '1.6', margin: 0 }}>
            {step.text}
          </p>
          {index < steps.length - 1 && <div className="wow-separator" />}
        </div>
      ))}
    </div>
  );
}
